import {Storage} from "@/Services/Storage";

export default {
    name : `bank`,
    state: {
        banks : [],
        agent : null
    },
    getters: {
        getAllBanks: (state) => state.banks,
        getAgent: (state) => Storage.getAdminUser(),
    },
    mutations: {
        setBanks : (state , payload) => state.banks = payload,
        setBankImage : (state, payload) => {
            state.banks = state.banks.map(row => {
                if (row.id === payload.id) {
                    if (payload.logo) row.logo = `data:image/png;base64,${payload.logo}`
                }
                return row;
            });
        },
        setAgent : async (state , payload) => {
            if (!payload) payload = Storage.getAdminUser();
            else await Storage.setAdminUser(payload)
            state.agent = payload
        },
        clearAgent : async (state) => {
            state.agent = null;
            await Storage.removeAdminUser();
        },
    },
    actions: {
        getAllBanks : (context) =>{
            return axios.get(bankApi+`bank/banks`)
                .then(async ({data})=> {
                    data = data.response.map(bank=>{
                        bank.logo = ``
                        return bank;
                    })
                    await context.commit(`setBanks`, data)
                    context.dispatch(`getAllBanksImages`)
                })
                .catch(err=>errorHandler.tomcatError(err))
        },
        getBankImage:(context , bankID) =>{
            return axios.get(bankApi+`bank/getBanksImage/${bankID}`)
                .then(({data})=> {
                    data = {
                        logo : data.data,
                        id : bankID
                    }
                    context.commit(`setBankImage` , data)
                });
        },
        getAllBanksImages : (context)=>{
            let banks = context.getters.getAllBanks;
            let imagesMethods = banks.map(bank=>{
                return context.dispatch(`getBankImage`,bank.id);
            })
            return Promise.all(imagesMethods);
        },

        agentLogin : async (context , payload) => {
            return axios.post(bankApi+`bankAgents/agentLogin`,payload)
                .then(({data})=> {
                    context.commit(`setAgent`, data.response)
                    return responses.showSuccess(`Login Success`)
                }).catch(err=>errorHandler.tomcatError(err))
        }

    },
}
